import { render, staticRenderFns } from "./parking_spaces_assignment.vue?vue&type=template&id=1304b91f&scoped=true&"
import script from "./parking_spaces_assignment.vue?vue&type=script&lang=js&"
export * from "./parking_spaces_assignment.vue?vue&type=script&lang=js&"
import style0 from "./parking_spaces_assignment.vue?vue&type=style&index=0&id=1304b91f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1304b91f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/andres/repositories/merge/webapp/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib'
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VContainer } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VSelect } from 'vuetify/lib'
import { VSwitch } from 'vuetify/lib'
installComponents(component, {VAlert,VBtn,VCard,VCardText,VCardTitle,VChip,VContainer,VDataTable,VFlex,VIcon,VLayout,VSelect,VSwitch})
